import React from "react";

import DropdownSelectStyles from "./DropdownSelect.css";

/* eslint-disable import/no-webpack-loader-syntax */

import DropdownArrowIcon from "-!svg-react-loader!../icons/dropdown-orange.svg";

import utilities from "./Utilities";

let Utilities = new utilities();

export default class DropdownSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      items: [],
      itemsProcessed: [],
      currentItem: null,
      minFrameWidth: 1.5,
      frameItems: "yo"
    };
  }

  toggle = (e, a, b) => {
    if (
      e !== undefined &&
      (e.target.getAttribute("data-disabled") === "true" ||
        e.target.parentNode.getAttribute("data-disabled") === "true" ||
        e.target.parentNode.parentNode.getAttribute("data-disabled") ===
          "true" ||
        e.target.parentNode.parentNode.parentNode.getAttribute(
          "data-disabled"
        ) === "true" ||
        e.target.parentNode.parentNode.parentNode.parentNode.getAttribute(
          "data-disabled"
        ) === "true" ||
        e.target.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
          "data-disabled"
        ) === "true")
    ) {
      return;
    }

    // Closing other instances

    let nodes = document.getElementsByClassName("dropdown-select-container");

    for (let i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute("data-open", "false");
    }

    this.setState({
      open: !this.state.open
    });

    let value = e.currentTarget.getAttribute("data-value");
    let value2 = e.currentTarget.getAttribute("data-value-2");

    if (this.props.name === "style" && value2 === null) {
      return;
    }

    if (!e.target.classList.contains("selected")) {
      this.props.onChange({
        name: this.props.name,
        value: value,
        value2: value2,
        a: a,
        b: b
      });

      this.setState({
        // TODO find index
        currentItem: this.getEntryByValue(value)
      });
    }
  };

  getEntryByValue = getValue => {
    for (let i = 0; i < this.state.items.length; i++) {
      if (this.state.items[i].value === getValue) {
        return this.state.items[i];
      }
    }

    return null;
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      items: nextProps.items
    });

    if (!Utilities.isENU(nextProps.value)) {
      this.setState({
        currentItem: nextProps.value
      });
    }

    if (nextProps.type === "hanging") {
      console.log(
        "Attempt to change hagning display values",
        nextProps.items,
        "==========="
      );
      // If unavailable get first one available, check i each categroy available, if yes choose the default value

      let wirePairFirst = null;

      this.setState({
        itemsProcessed: nextProps.items.map(item => {
          if (item.displayName === "Wire") {
            if (!wirePairFirst) {
              wirePairFirst = item;
              return null;
            } else {
              item.maxDimLarge =
                item.maxDimLarge > wirePairFirst.maxDimLarge
                  ? item.maxDimLarge
                  : wirePairFirst.maxDimLarge;
              item.maxDimSmall =
                item.maxDimSmall > wirePairFirst.maxDimSmall
                  ? item.maxDimSmall
                  : wirePairFirst.maxDimSmall;
              item.component =
                item.maxDimSmall > wirePairFirst.maxDimSmall
                  ? item.component
                  : wirePairFirst.component;
            }
          }
          return item;
        })
      });
    }
  }

  componentWillMount() {
    document.addEventListener("mousedown", this.handleClick, false);
    // console.log(this.props.height, this.props.width);
    const styleObj = [{ 1.5: 70 }, { 2.0: 110 }];
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick, false);
  }

  handleClick = e => {
    if (this.node.contains(e.target)) {
      return;
    }

    this.setState({
      open: false
    });
  };

  setFrameSize() {
    const frameItems = this.props.items.map(item => {
      return item;
    });

    this.setState({
      frameItems: frameItems
    });
  }

  componentDidMount() {
    let newState = {};

    if (this.props.items !== undefined) {
      newState.items = this.props.items;
    }

    if (!Utilities.isENU(this.props.value)) {
      newState.currentItem = this.props.value;
    }

    this.setState(newState, function() {});

    this.setFrameSize();
  }

  render() {
    let selectedDOM = "";
    let optionsDOM = "";

    // console.log(this.props.value);

    if (this.state.items.length !== 0) {
      switch (this.props.type) {
        case "color":
          selectedDOM = (
            <div
              onClick={e => {
                this.toggle(e);
              }}
              data-value={
                this.state.currentItem !== null
                  ? this.state.currentItem.value
                  : this.state.items[0].value
              }
              className='option selected'
            >
              <span
                className='color'
                data-color={
                  this.state.currentItem !== null
                    ? this.state.currentItem.color
                    : this.state.items[0].color
                }
                style={{
                  backgroundColor:
                    "#" +
                    (this.state.currentItem !== null
                      ? this.state.currentItem.rgb
                      : this.state.items[0].rgb)
                }}
              ></span>
              <span className='value'>
                {this.state.currentItem !== null
                  ? Utilities.capitalize(this.state.currentItem.name)
                  : Utilities.capitalize(this.state.items[0].name)}
              </span>
            </div>
          );
          // if (this.props.height <= 120 && this.props.width <= 80) {
          //   optionsDOM = (
          //     <div className='options'>
          //       {this.state.items.map((item, i) => {
          //         return (
          //           <div
          //             onClick={e => {
          //               this.toggle(e);
          //             }}
          //             className='option'
          //             data-value={item.value}
          //           >
          //             <span
          //               className='color'
          //               data-color={item.color}
          //               style={{
          //                 backgroundColor: "#" + item.rgb
          //               }}
          //             ></span>
          //             <span className='value'>
          //               {Utilities.index(item.name)}
          //             </span>
          //           </div>
          //         );
          //       })}
          //     </div>
          //   );
          // } else {
          optionsDOM = (
            <div className='options'>
              {this.state.items.map((item, i) => {
                return (
                  <div
                    onClick={e => {
                      this.toggle(e);
                    }}
                    className='option'
                    data-value={item.value}
                  >
                    <span
                      className='color'
                      data-color={item.color}
                      style={{
                        backgroundColor: "#" + item.rgb
                      }}
                    ></span>
                    <span className='value'>
                      {Utilities.capitalize(item.name)}
                    </span>
                  </div>
                );
              })}
            </div>
          );

          break;

        case "style":
          selectedDOM = (
            <div
              onClick={e => {
                e.preventDefault();
                this.toggle(e);
              }}
              data-value={
                this.state.currentItem !== null
                  ? this.state.currentItem.value
                  : this.state.items[0].value
              }
              data-value-2={
                this.state.currentItem !== null
                  ? this.state.currentItem.id
                  : this.state.items[0].id
              }
              className='option clearfix selected'
            >
              <span
                className='img'
                data-color={
                  this.state.currentItem !== null
                    ? this.state.currentItem.color
                    : this.state.items[0].color
                }
              >
                <span
                  style={{
                    backgroundColor:
                      "#" +
                      (this.state.currentItem !== null
                        ? this.state.currentItem.rgb
                        : this.state.items[0].rgb)
                  }}
                ></span>
                <span
                  style={{
                    backgroundColor:
                      "#" +
                      (this.state.currentItem !== null
                        ? this.state.currentItem.rgb
                        : this.state.items[0].rgb)
                  }}
                ></span>
              </span>
              <div className='text_block_drop'>
                <span className='value'>
                  {this.state.currentItem !== null
                    ? this.state.currentItem.name
                    : this.state.items[0].name}
                </span>
                <span
                  className='description'
                  dangerouslySetInnerHTML={{
                    __html:
                      this.state.currentItem !== null
                        ? this.state.currentItem.description
                        : this.state.items[0].description
                  }}
                ></span>
              </div>
            </div>
          );
          optionsDOM = (
            <div className='options'>
              {this.state.items.map((item, i) => {
                return (
                  <div
                    onClick={e => {
                      this.toggle(e);
                    }}
                    className='option clearfix'
                    data-value={item.value}
                    data-value-2={item.id}
                  >
                    <span className='img' data-color={item.color}>
                      <span style={{ backgroundColor: "#" + item.rgb }}></span>
                      <span style={{ backgroundColor: "#" + item.rgb }}></span>
                    </span>
                    <div>
                      <span className='value'>{item.name}</span>
                      <span
                        className='description'
                        dangerouslySetInnerHTML={{ __html: item.description }}
                      ></span>
                    </div>
                  </div>
                );
              })}
            </div>
          );
          break;

        case "hanging":
          selectedDOM = (
            <div
              data-disabled={
                this.state.currentItem !== null
                  ? this.state.currentItem.value
                  : this.state.items[0].value
              }
              onClick={e => {
                this.toggle(e);
              }}
              data-value={
                this.state.currentItem !== null
                  ? this.state.currentItem.value
                  : this.state.items[0].value
              }
              className='option selected'
            >
              {this.state.currentItem !== null
                ? this.state.currentItem.displayName
                : this.state.items[0].displayName}
              {this.props.calculator.isNotAllowedHangingComponent(
                this.state.currentItem !== null
                  ? this.state.currentItem.value
                  : this.state.items[0].value
              ) && <span className='disabled'>Not available</span>}
            </div>
          );

          let foundSuitableWire = false;
          let foundOneWire = false;

          optionsDOM = (
            <div className='options'>
              {this.state.items.map((item, i) => {
                // console.log("==========", item)

                // Just show one Wires
                if (item.displayName === "Wire") {
                  // Not foud a single wire so far
                  if (!foundOneWire) {
                    foundOneWire = true;
                    console.log("++ Just found first wire");
                    // Found a suitable wire so we will use this if wire is selected by user (downgrade)
                    if (
                      !this.props.calculator.isNotAllowedHangingComponent(
                        item.value
                      )
                    ) {
                      console.log("++ and it's suitable");
                      foundSuitableWire = true;
                      if (
                        this.props.calculator.userFields.hanging.indexOf(
                          "Wire"
                        ) > -1 &&
                        this.props.calculator.userFields.hanging !==
                          item.component
                      ) {
                        console.log("++ And we are autoupdating");
                        this.props.onChange({
                          value: item.component,
                          b: item.displayName,
                          name: "hanging"
                        });
                      }
                    } else {
                      // Not suitable but next one might be
                      return;
                    }
                  } else {
                    // If the first one already ok then no need to render this
                    if (foundSuitableWire) {
                      console.log("++ Just found second but no render");
                      return;
                    } else {
                      console.log("++ Just found second wire");
                      // if second one is suitable select this if not preselected anything else as well (upgrade)
                      if (
                        !this.props.calculator.isNotAllowedHangingComponent(
                          item.value
                        )
                      ) {
                        console.log("++ and this is suitable");
                        if (
                          this.props.calculator.userFields.hanging.indexOf(
                            "Wire"
                          ) > -1 &&
                          this.props.calculator.userFields.hanging !==
                            item.component
                        ) {
                          console.log("++ and autoselecteing");
                          this.props.onChange({
                            value: item.component,
                            b: item.displayName,
                            name: "hanging"
                          });
                        }
                      }
                      // Render it either way regardless whether it's suitable or not
                    }
                  }
                }

                return (
                  <div
                    onClick={e => {
                      this.toggle(e, item.name, item.displayName);
                    }}
                    className='option'
                    data-value={item.value}
                    data-disabled={this.props.calculator.isNotAllowedHangingComponent(
                      item.value
                    )}
                  >
                    {item.displayName}
                    {this.props.calculator.isNotAllowedHangingComponent(
                      item.value
                    ) && <span className='disabled'>Not available</span>}
                  </div>
                );
              })}
            </div>
          );
          break;

        case "regular":
        default:
          selectedDOM = (
            <div
              onClick={e => {
                this.toggle(e);
              }}
              data-value={
                this.state.currentItem !== null
                  ? this.state.currentItem.value
                  : this.state.items[0].value
              }
              className='option selected'
            >
              {this.state.currentItem !== null
                ? this.state.currentItem.name
                : this.state.items[0].name}
            </div>
          );
          optionsDOM = (
            <div className='options'>
              {this.state.items.map((item, i) => {
                return (
                  <div
                    onClick={e => {
                      this.toggle(e);
                    }}
                    className='option'
                    data-value={item.value}
                  >
                    {item.name}
                  </div>
                );
              })}
            </div>
          );
          break;
      }
    }

    return (
      <div
        ref={node => (this.node = node)}
        className='dropdown-select-container'
        data-open={this.state.open}
        data-type={this.props.type}
        data-disabled={this.props.disabled}
      >
        <div className='select-container selected'>
          <div className='select'>
            {this.state.items.length !== 0 ? selectedDOM : null}
            {this.state.items.length !== 0 ? optionsDOM : null}
            {this.state.items.length === 0 ? (
              <div className='option selected'>Failed to Load</div>
            ) : null}
          </div>
          <DropdownArrowIcon
            onClick={() => {
              this.toggle();
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DropdownSelect.js